import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { mutateAsync } from "redux-query";
import { loginQuery } from "../../actions/queries";
import { minIOPasswordByRegionId, minIOUserByRegionId } from "../../constants/formOptions";
import { statusIsGood } from "../../utils/helpers";
import { useCurrentUser } from "../useCurrentUser"
import { useSelectedRecord } from "../useSelectedRecord";

const UPLOAD_URL = process.env.REACT_APP_UPLOAD_URL || 'http://129.116.70.173:8080/java_minio2/UploadFile'
const TDIS_AUTH_URL_BASE = process.env.REACT_APP_TDIS_AUTH_URL_BASE || 'https://ms2-dev.tacc.utexas.edu/tdis_authentication/api'

const getBashScript = (username, password, bucket, minIOUser, minIOPassword) => {
  return (
`#!/bin/bash
# Upload script for TDIS Ingest
# Author: Brent Porter bporter@csr.utexas.edu
# Last Update:  12/16/2021 12/29/2021 01/04/2022 01/26/2022 03/21/2022
# Last Updated By: Brent Porter
# This is multistep script there is a single dependency on the jq library to parse the json response to capture the JWT info
# First Credentials have to be written in the first two lines
# These are used to get a valid JWT that can be used in conjunction with TACC MinIO Svr credentials to authenticate and upload files
# The JWT is validated along with the MinIO credentials by the Ingest Endpoint
# The upload process is recursive from the directory provided as a parameter after the script, the script will try to upload one at
# time every file it finds within the starting directory.
# syntax is ./nix_upload.sh <<starting directory>>
# The script generates a report created in the run directory that is appended each time thereafter with the filename along with date and time of upload
###########

## Initial credentials for JWT TODO these will have to be tied to the user credentials for each of the uploaders
username=${username}
password=${password}

minIO_user=${minIOUser}
minIO_password=${minIOPassword}

## S3 Bucket Name - TODO this should come from the script generated when you fill out the metadata along with user credentials for the upload
bucket=${bucket}


TOKEN=$(curl -s -X POST -H 'Accept: application/json' -H 'Content-Type: application/json' --data '{"username":"'"\${username}"'","password":"'"\${password}"'"}' ${TDIS_AUTH_URL_BASE}/auth/signin | jq -r '.accessToken')
echo "$TOKEN"

IFS=$'\n'; set -f
for f in $(find \${1} -name '*.*');
do
b=$(basename $f)
echo $b
   curl -H "x-access-token: \${TOKEN}" -include --form file=@"$f" --form filename=$b --form username=\${minIO_user} --form credentials=\${minIO_password} --form bucket=\${bucket} --form filepath=$f "${UPLOAD_URL}"
   now=$(date +"%m_%d_%Y_%T")
   echo "******* $now *********" >> ./reportOutput.txt
   echo "Finished $f file at $now" >> ./reportOutput.txt
   echo "Finished $f file"
   echo "******* Finished File *******" >> ./reportOutput.txt
done

unset IFS; set +f`
  )
}

export const useBashDownload = (recordId) => {
  const dispatch = useDispatch();
  const [selectedRecord] = useSelectedRecord();
  const { username } = useCurrentUser();
  // const password = useSelector(passwordSelector);
  const regionId = (selectedRecord ? selectedRecord.currentMetadata.twdbFloodPlanningRegionID : null) || '01';
  const bucket = `twdb-region-${regionId}`;
  const minIOUser = minIOUserByRegionId[regionId];
  const minIOPassword = minIOPasswordByRegionId[regionId];

  const promptForPassword = () => {
    const passwordInput = prompt("Please re-enter your password", "");
    dispatch(mutateAsync(loginQuery({ username, password: passwordInput }))).then(({ status }) => {
      if (statusIsGood(status)) {
        getFile(passwordInput);
      } else {
        toast.error("Incorrect password, please try again")
      }
    })
  }

  const getFile = (currentPassword) => {
    const exportedFilename = `upload_script.sh`;
    var blob = new Blob([getBashScript(username, currentPassword, bucket, minIOUser, minIOPassword)], { type: 'text/plain;charset=utf-8;' });
    if (navigator.msSaveBlob) { // IE 10+
        navigator.msSaveBlob(blob, exportedFilename);
    } else {
        var link = document.createElement("a");
        if (link.download !== undefined) { // feature detection
            // Browsers that support HTML5 download attribute
            var url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", exportedFilename);
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }
  }
  return promptForPassword;
}